import React, { forwardRef } from 'react'

const PartnerNew = forwardRef((props, ref) => {
  const partnersGroup1 = [
    'images/busan.png',
    'images/police.png',
    'images/hyundai.png',
    'images/gyeonggi.png',
    'images/jeju.png',
    'images/koexpressway.png'
  ];

  const partnersGroup2 = [
    'images/kt.png',
    'images/incheon.png',
    'images/GAPYEONG_Logo.jpeg',
    'images/PUG_Logo1.png',
    'images/YANGPYONG_Logo2.svg',
    'images/GWANGJU_Logo.svg'
  ];

  const partnersGroup3 = [
    'images/HANAM_Logo.png',
    'images/Chungju_Logo.jpg',
    'images/대전광역시.png',
    'images/수원시도시공사.svg',
    'images/동두천시.png',
    'images/부천도시공사.svg'
  ];

  const partnersGroup4 = [
    'images/시흥로고.svg',
    'images/안산도시공사.png',
    'images/안성시.gif',
    'images/여주도시공사.jfif',
    'images/충청남도.jpg',
    'images/포항시.svg'
  ];
  const renderGroup = (partners, delay = false) => (
    <div className={`group${delay ? ' delay' : ''}`} >
      {partners.map((src, index) => (
        <div className='partner_img' key={index}>
          <img className='partner_imgaes' src={src} alt="Partner Logo" />
        </div>
      ))}
    </div>
  );
  const renderGroupHidden = (partners, delay = false) => (
    <div className={`group${delay ? ' delay' : ''}`} aria-hidden>
      {partners.map((src, index) => (
        <div className='partner_img' key={index}>
          <img className='partner_imgaes' src={src} alt="Partner Logo" />
        </div>
      ))}
    </div>
  );

  return (
    <div className='partner_sub_new'>
      <span className='partner_h2'><strong className='partner_strong'>e<strong className='partner_edge'>K</strong>sys</strong>의 고객사</span>
      <span className='partner_sub_span'>eksys는 설립이래 GIS 솔루션 기반 시스템 구축 및 LBS 서비스 등을 비즈니스 모델로 하여 고객가치를 창조하고 있습니다</span>
      {/* <div className="carousel">
          <div className="group">
            <div className='partner_img'><img className='partner_imgaes' src='images/kt.png' /></div>
            <div className='partner_img'><img className='partner_imgaes' src='images/incheon.png' /></div>
            <div className='partner_img'><img className='partner_imgaes' src='images/YANGPYONG_Logo2.svg' /></div>
            <div className="partner_img"><img className='partner_imgaes' src='images/GWACHEON_Logo.gif' /></div>
            <div className='partner_img'><img className='partner_imgaes' src='images/Chungju_Logo.jpg' /></div>
            <div className='partner_img'><img className='partner_imgaes' src='images/HANAM_Logo.png' /></div>
          </div>
          <div className="group" aria-hidden>
            <div className='partner_img'><img className='partner_imgaes' src='images/kt.png' /></div>
            <div className='partner_img'><img className='partner_imgaes' src='images/incheon.png' /></div>
            <div className='partner_img'><img className='partner_imgaes' src='images/YANGPYONG_Logo2.svg' /></div>
            <div className="partner_img"><img className='partner_imgaes' src='images/GWACHEON_Logo.gif' /></div>
            <div className='partner_img'><img className='partner_imgaes' src='images/Chungju_Logo.jpg' /></div>
            <div className='partner_img'><img className='partner_imgaes' src='images/HANAM_Logo.png' /></div>
          </div>
        </div> */}
      <div className="carousel">
        {renderGroup(partnersGroup1)}
        {renderGroupHidden(partnersGroup1)}
      </div>
      <div className="carousel">
        {renderGroup(partnersGroup2,'delay')}
        {renderGroupHidden(partnersGroup2, true)}
      </div>
      <div className="carousel">
        {renderGroup(partnersGroup3)}
        {renderGroupHidden(partnersGroup3)}
      </div>
      <div className="carousel">
        {renderGroup(partnersGroup4,'delay')}
        {renderGroupHidden(partnersGroup4, true)}
      </div>
    </div>
  );
})

export default PartnerNew
